import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "message",
  "use": "message-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"message\">\n<path d=\"M11.75 4.5H5.25C4.8125 4.5 4.5 4.84375 4.5 5.25C4.5 5.6875 4.8125 6 5.25 6H11.75C12.1562 6 12.5 5.6875 12.5 5.25C12.5 4.84375 12.1562 4.5 11.75 4.5ZM8.75 7.5H5.25C4.8125 7.5 4.5 7.84375 4.5 8.25C4.5 8.6875 4.8125 9 5.25 9H8.75C9.15625 9 9.5 8.6875 9.5 8.25C9.5 7.84375 9.15625 7.5 8.75 7.5ZM14.5 0H2.5C1.375 0 0.5 0.90625 0.5 2V11.0312C0.5 12.125 1.375 13.0312 2.5 13.0312H5.5V15.6562C5.5 15.9375 5.84375 16.125 6.09375 15.9375L10 13.0312H14.5C15.5938 13.0312 16.5 12.125 16.5 11.0312V2C16.5 0.90625 15.5938 0 14.5 0ZM15 11.0312C15 11.2812 14.75 11.5312 14.5 11.5312H9.5L7 13.4062V11.5312H2.5C2.21875 11.5312 2 11.2812 2 11.0312V2C2 1.75 2.21875 1.5 2.5 1.5H14.5C14.75 1.5 15 1.75 15 2V11.0312Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/message.svg
// module id = Jb5w
// module chunks = 13